import React, { useEffect, useState } from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import MainScreen from "screens/MainScreen";
import Login from "screens/Login/Login";
import { getEnvs } from "./env";
import TextPage from "components/TextPage/TextPage";


const PrivateRoute: React.FC<{
  component: React.FC;
  path: string;
  status?: string;
}> = ({ component: Component, path: path, ...rest }) => {

  const [isAuth, setIsAuth] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const validateUser = async () => {
    const envvars: any = await getEnvs();
    const serverUrl = envvars.REACT_APP_SERVER_URL_API;
    const result = await fetch(`${serverUrl}/userValid`, { credentials: "include" })
    if (result.status === 204) {
      setIsAuth(true)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    validateUser()
  });

  return isLoading ? null :
    isAuth ? (<Route exact path={path} render={props => <Component {...rest} />} />) :
      (<Redirect to="/" />);
};


const Routes: React.FC = () => {
  return (
    <HashRouter>
      <Switch>
        <PrivateRoute component={MainScreen} path="/main" />
        <PrivateRoute path="/about" component={TextPage} status="about" />
        <Route exact path="/">
          <Login />
        </Route>
        <Redirect from="*" to='/main' />
      </Switch>
    </HashRouter>
  );
};

export default Routes;
